import 'normalize.css/normalize.css'
import 'animate.css/animate.css'
import './css/main.styl'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import VueLodash from 'vue-lodash'
import moment from 'vue-moment'
import VueResize from 'vue-resize'
import { sync } from 'vuex-router-sync'
import { i18n, loadLanguageAsync } from './library/cdu/translations'

sync(store, router)

Vue.use(VueResize)
Vue.use(VueLodash)
Vue.use(moment)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',
  created: function () {
    loadLanguageAsync()
  }
})



// WEBPACK FOOTER //
// ./src/main.js